import { ofType } from "redux-observable";
import { merge, of } from "rxjs";
import { filter, map } from "rxjs/operators";
import { selectAreSceneDependenciesLoaded } from "../../selectors/selectSceneInfo";
import { TypeActionLoading } from "../loading/actionLoading";
import { actionSceneSwap } from "./actionScenes";
import { IdScene } from "./types/IdScene";
export var pathWaitTillDependenciesLoad = function (scene, action$) { return function (swapAction, state$, deps) {
    if (selectAreSceneDependenciesLoaded(state$.value, scene)) {
        return of(actionSceneSwap(scene.sceneId));
    }
    var complete$ = action$.pipe(ofType(TypeActionLoading.Complete), filter(function (action) {
        return (scene.assetBundleDependencies.find(function (bundleId) { return action.bundleId === bundleId; }) !=
            undefined);
    }), map(function () {
        var state = state$.value;
        return selectAreSceneDependenciesLoaded(state, scene)
            ? actionSceneSwap(scene.sceneId)
            : actionSceneSwap(IdScene.Loading);
    }));
    var start$ = of(actionSceneSwap(IdScene.Loading));
    return merge(start$, complete$);
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/scenes/pathWaitTillDependenciesLoad.ts
// module id = 2129
// module chunks = 3